import { MetadataCategory } from '@cube3/common/model/schema/resources/metadata-category';
import { FORMAT_C3_YEAR_DATE } from '@cube3/common/model/schema/resources/metadata-field';
import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { useTypedSelector } from '@cube3/state/src/redux/components/Hooks/useTypedSelector';
import moment from 'moment';
import { useMemo } from 'react';
import { getFormValues } from 'redux-form';

const getYear = (val) => val && moment(val).year().toString();

export const useGenerateProjectNameByMetadataValues = (
  cats: MetadataCategory[] = []
) => {
  const currentWorkspace = useCurrentWorkspace()[1];

  const formValues = useTypedSelector((state) => {
    return cats.reduce((acc, cat) => {
      const values = getFormValues(cat?.id)(state) || {};
      return { ...acc, ...values };
    }, {});
  });

  const yearFields = useMemo(() => {
    const fields = cats.map((c) => c.metadata_fields).flat();
    return fields
      .filter(
        (f) =>
          f.value_type === 'date' &&
          f.json_schema &&
          JSON.parse(f.json_schema)?.format === FORMAT_C3_YEAR_DATE
      )
      .map((fd) => fd.id);
  }, [cats]);

  const nameTemplate = currentWorkspace?.project_name_string_template;

  return formValues
    ? nameTemplate.replaceAll(
        /{{metadata\.([a-zA-Z0-9]+)(:[duls]+)?}}/g,
        (match, id, op) => {
          const key = 'field_' + id;
          let val;
          if (yearFields.includes(id)) {
            val = getYear(formValues[key]);
          } else {
            val = formValues[key];
          }

          if (val && op) {
            if (op.includes('d')) {
              val = val.toString().replaceAll(/\s/g, '-');
            }
            if (op.includes('s')) {
              val = val.toString().replaceAll(/\s/g, '_');
            }
            if (op.includes('l')) {
              val = val.toString().toLowerCase();
            }
            if (op.includes('u')) {
              val = val.toString().toUpperCase();
            }
          }
          return val;
        }
      )
    : '';
};
